import * as PIXI from 'pixi.js'

export const centerAnchor = new PIXI.Point(0.5, 0.5)
export const centerTopAnchor = new PIXI.Point(0.5, 0)
export const centerBottomAnchor = new PIXI.Point(0.5, 1)
export const bottomRightAnchor = new PIXI.Point(1, 1)
